







































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { OnlineNewsDTO } from "@/model/component.model";
import BannerService from "@/services/BannerService";

@Component({})
export default class ArticleNewsWidget extends Vue {
  news: OnlineNewsDTO[] = [];

  async created() {
    await this.fetchNews();
  }

  async fetchNews() {
    try {
      this.news = await BannerService.prototype.getNews();
      this.news.forEach((news, i) => {
        this.news[i].description = news.description.replace(
          /(?:\r\n|\r|\n)/g,
          "<br>"
        );
      });
    } catch (err) {
      console.error(err);
    }
  }

  async openLink(item: OnlineNewsDTO) {
    if ((window as any).dataLayer) {
      const layerData = {
        event: "click_cta_news",
        event_data: {
          click_text: "FIND OUT MORE",
          link_url: item.iperLink
        }
      };
      (window as any).dataLayer.push(layerData);
    }
    window.open(item.iperLink, "_blank");
  }
}
